import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common-ui-components/dist/components/Atoms/Button';
import { ReactSVG } from 'react-svg';
import './ShoppingCartUtilityButtons.scss';

const ShoppingCartUtilityButtons = props => {
  const {
    removeAllItems,
    downloadItems,
    removeAllItemsIconUrl,
    downloadItemsIconUrl,
    setIsModalRemoveAllOpen,
    downloadCart,
  } = props;

  return (
    <div className="shoppingCartUtilityButtons row">
      <Button
        className="utilityBorder row middle-xs"
        onClick={setIsModalRemoveAllOpen}
        elementLocator="button-shopping-cart-remove-all-item"
        ariaLabel={removeAllItems}
      >
        {removeAllItems}
        <ReactSVG className="icon" src={removeAllItemsIconUrl} />
      </Button>
      <Button
        className="utilityBorder row middle-xs"
        onClick={downloadCart}
        elementLocator="button-shopping-download-cart"
        ariaLabel={downloadItems}
      >
        {downloadItems}
        <ReactSVG className="icon" src={downloadItemsIconUrl} />
      </Button>
    </div>
  );
};

ShoppingCartUtilityButtons.propTypes = {
  removeAllItems: PropTypes.string,
  downloadItems: PropTypes.string,
  removeAllItemsIconUrl: PropTypes.string,
  downloadItemsIconUrl: PropTypes.string,
  setIsModalRemoveAllOpen: PropTypes.func,
  downloadCart: PropTypes.func,
};

ShoppingCartUtilityButtons.defaultProps = {
  removeAllItems: '',
  downloadItems: '',
  removeAllItemsIconUrl: '',
  downloadItemsIconUrl: '',
  setIsModalRemoveAllOpen: () => {
    /* default setIsModalRemoveAllOpen handler */
  },
  downloadCart: () => {
    /* default downloadCart handler */
  },
};

export default ShoppingCartUtilityButtons;
